module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/li-572f90277090beca0d31315cec8e1bf4.svg";